import { useEffect } from 'react';

// Component to handle performance optimizations
const PerformanceOptimizer = () => {
  useEffect(() => {
    // Track page load performance
    if (window.performance && window.gtag) {
      // After the page is fully loaded
      window.addEventListener('load', () => {
        // Get performance timing data
        const perfData = window.performance.timing;
        const pageLoadTime = perfData.loadEventEnd - perfData.navigationStart;
        const domReadyTime = perfData.domComplete - perfData.domLoading;
        
        // Report to Google Analytics
        window.gtag('event', 'timing_complete', {
          'name': 'page_load',
          'value': pageLoadTime,
          'event_category': 'Performance'
        });
        
        window.gtag('event', 'timing_complete', {
          'name': 'dom_ready',
          'value': domReadyTime,
          'event_category': 'Performance'
        });
      });
    }
    
    // Preload key resources
    const preloadResources = () => {
      // Preload images or other resources that might be needed soon
      const links = [
        { rel: 'preload', href: '/calculator.svg', as: 'image' }
      ];
      
      links.forEach(linkData => {
        const link = document.createElement('link');
        Object.entries(linkData).forEach(([key, value]) => {
          link[key] = value;
        });
        document.head.appendChild(link);
      });
    };
    
    preloadResources();
    
    // Implement Intersection Observer for lazy loading
    const setupLazyLoading = () => {
      if ('IntersectionObserver' in window) {
        const lazyLoadObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const lazyElement = entry.target;
              
              // If it's an image with data-src
              if (lazyElement.tagName === 'IMG' && lazyElement.dataset.src) {
                lazyElement.src = lazyElement.dataset.src;
                lazyElement.removeAttribute('data-src');
              }
              
              // If it has a lazy-load-bg class for background images
              if (lazyElement.classList.contains('lazy-load-bg') && lazyElement.dataset.bg) {
                lazyElement.style.backgroundImage = `url(${lazyElement.dataset.bg})`;
                lazyElement.removeAttribute('data-bg');
              }
              
              lazyLoadObserver.unobserve(lazyElement);
            }
          });
        });
        
        // Observe all elements with lazy-load class
        document.querySelectorAll('.lazy-load').forEach(element => {
          lazyLoadObserver.observe(element);
        });
      }
    };
    
    // Run after DOM is fully loaded
    if (document.readyState === 'complete') {
      setupLazyLoading();
    } else {
      window.addEventListener('load', setupLazyLoading);
    }
    
    return () => {
      window.removeEventListener('load', setupLazyLoading);
    };
  }, []);
  
  return null; // This component doesn't render anything
};

export default PerformanceOptimizer;